/**
 * Accordion
 */

import 'bootstrap/js/dist/collapse';

// Module dependencies
import 'protons';
import 'atoms/button';
import 'molecules/card';

// Module template
import './_paragraph-accordion.twig';
import './_paragraph-accordion-item.twig';

// Module styles
import './_paragraph-accordion.scss';

export const name = 'accordion';

export function disable() {}

export function enable() {}

export default enable;


// This is automatically added by drupal-behaviors-loader
Drupal.behaviors[name] = {
  attach: enable,
  detach: disable,
};